import React__default from "react";
const __variableDynamicImportRuntimeHelper = (glob, path, segs) => {
  const v = glob[path];
  if (v) {
    return typeof v === "function" ? v() : Promise.resolve(v);
  }
  return new Promise((_, reject) => {
    (typeof queueMicrotask === "function" ? queueMicrotask : setTimeout)(
      reject.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + path + (path.split("/").length !== segs ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
};
class ErrorBoundary extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false
    };
  }
  componentDidCatch() {
    this.setState({ error: true });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.reset !== this.props.reset) {
      this.setState({ error: false });
    }
  }
  render() {
    return this.state.error ? this.props.fallback : this.props.children;
  }
}
export {
  ErrorBoundary as E,
  __variableDynamicImportRuntimeHelper as _
};
//# sourceMappingURL=ErrorBoundary.js.map
